import { colors } from '@kmns-internal/furikake/tokens'
import { LinearProgress } from '@mui/material'

type Props = {
  /** 実施率（0〜100 のパーセント値） */
  rate: number
}

/**
 * 実施率を表す横棒グラフ（バー描画部分のみ）
 *
 * 全体の実施率（OverallSubmissionRate）と現場ごとの実施率（SubmissionRateBar）の
 * 両方から利用する共通部品。バーの見た目（高さ・色など）の定義をここに集約し、
 * 二重メンテにならないようにする。
 *
 * Figma / PD コメント: 通常は gray[6]、100% 達成時のみ indigo[6] を利用する。
 */
export const SubmissionRateProgress = ({ rate }: Props) => {
  const isComplete = rate >= 100

  return (
    <LinearProgress
      variant="determinate"
      value={Math.min(100, Math.max(0, rate))}
      sx={{
        height: 8,
        borderRadius: 1,
        backgroundColor: colors.action.disabledBackground,
        '& .MuiLinearProgress-bar': {
          backgroundColor: isComplete ? colors.indigo[6] : colors.gray[6],
        },
      }}
    />
  )
}
